import { useSelector } from 'react-redux';
import { isLoginUser } from './auth';

export const useUserObj = () => {
  let userObj = {};
  const { providerToken, error } = useSelector(
    (state: any) => state.providerReducer,
  );
  const { guestUser } = useSelector((state: any) => state.guestReducer);

  const userIsLoggedIn = isLoginUser ? isLoginUser() : !!providerToken;

  if (userIsLoggedIn && providerToken) {
    userObj = {
      first_name: providerToken.first_name || '',
      last_name: providerToken.last_name || '',
      email: providerToken.email || '',
      phone: providerToken.phone || '',
    };
  } else if (guestUser) {
    userObj = {
      first_name: guestUser.firstname || '',
      last_name: guestUser.lastname || '',
      email: guestUser.emailaddress || '',
      phone: guestUser.contactnumber || '',
    };
  }

  return userObj;
};
